import "core-js/modules/es.error.cause.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/logo.jpeg';
const _hoisted_1 = {
  class: "index-view"
};
const _hoisted_2 = {
  class: "header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo_layout"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("span", null, "翠微旅居")], -1);

const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "user-info"
};
const _hoisted_6 = {
  class: "el-dropdown-link"
};
const _hoisted_7 = {
  class: "image-slot"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import NavMenu from "@/components/NavMenu.vue";
import useRoute from "@util/router";
import { ref, reactive, computed, watch, onMounted } from "vue";
import { CaretBottom, User } from "@element-plus/icons-vue";
import LoginViewVue from "@view/account/LoginView.vue";
import event from "@util/eventBus";
import auth from "@net/auth";
import api from "@api/accout";
import $ from "@util/base";
import useAccoutStore from "@store/accout";
import usePermissionsStore from "@/store/permissions";
import { $msg } from "@/common/ui/msg";
export default {
  __name: 'App',

  setup(__props) {
    const accoutStore = useAccoutStore();
    const permissionsStore = usePermissionsStore();
    const isLogin = ref(auth.getToken() != null);
    event.registerEvent("AUTH_FAIL", () => {
      isLogin.value = false;
    });
    event.registerEvent("LOGIN", () => {
      isLogin.value = true;
    });
    const userInfo = ref({
      avatar: null,
      name: null,
      permissionList: null
    });
    var isFirst = true;

    function getUserInfo() {
      api.userInfo(val => {
        // userInfo.value = val;
        if (val.permissionList && val.permissionList.length > 0) {
          userInfo.value.avatar = val.avatar ? val.avatar : null;
          userInfo.value.name = val.name;
          userInfo.value.roleName = val.roleName;
          userInfo.value.shopCode = val.shopCode;
          userInfo.value.shopLevel = val.shopLevel;
          userInfo.value.shopName = val.shopName;
          let isAll = val.permissionList.indexOf("cw-manage-overview-all") != -1;
          auth.setOverView(isAll, val.shopCode, val.shopName);
          let isCombo = val.permissionList.indexOf("cw-manage-order-travel-combo") != -1;
          let isMember = val.permissionList.indexOf("cw-manage-order-travel-member") != -1;
          auth.setTravelOrder(isCombo, isMember); // 1040002分店 1040001总店

          accoutStore.setUserInfo({
            mainStore: val.shopLevel === '1040001' ? true : false
          });
          let pList = val.permissionList.map(item => {
            return item.code;
          });
          userInfo.value.permissionList = pList;
          permissionsStore.setPermissions(val.permissionList);
          permissionsStore.setPermissionCodes(pList);
          let btns = val.permissionList.filter(item => {
            return item.buttons;
          }).map(item => {
            return item.buttons;
          }).flat();
          permissionsStore.setBtnPermissions(btns);
          getMenuList.value = menuList.filter(e => {
            for (const key of userInfo.value.permissionList) {
              if (key.indexOf(e.code) != -1) {
                return true;
              }
            }

            return false;
          });

          if (isFirst) {
            isFirst = false;

            for (let i = 0; i < menuList.length; i++) {
              if (permissionsStore.permissionCodes.indexOf(menuList[i].code) != -1) {
                navRoute(menuList[i]);
                return;
              }
            } // setSecondMenu(curSecondMenu.value)

          }
        } else {
          $msg.error("没有权限");
          isLogin.value = false;
          setTimeout(() => {
            logOut();
          }, 1000);
        }
      });
    }

    onMounted(() => {
      if (isLogin.value) {
        // 如果已经登录，获取用户信息
        getUserInfo();
      }
    });
    const menuList = [{
      title: "概览",
      key: "overview",
      route: "/overview",
      icon: "DataAnalysis",
      code: "cw-manage-overview"
    }, {
      title: "酒店",
      key: "hotel",
      route: "/hotelinput",
      icon: "OfficeBuilding",
      code: "cw-manage-hotel"
    }, {
      title: "旅行",
      key: "travel",
      route: "/travelinput",
      icon: "Location",
      code: "cw-manage-travel"
    }, {
      title: "商品",
      key: "goods",
      route: "/goodsinput",
      icon: "Goods",
      code: "cw-manage-goods"
    }, {
      title: "团建",
      key: "teamBuilding",
      route: "/line",
      icon: "Help",
      code: "cw-manage-teamBuilding"
    }, {
      title: "订单",
      key: "order",
      route: "/goodsorder",
      icon: "Van",
      code: "cw-manage-order"
    }, {
      title: "营销",
      key: "marketing",
      route: "/promotionsmanager",
      icon: "Present",
      code: "cw-manage-market"
    }, {
      title: "相册",
      key: "memory",
      route: "/memory",
      icon: "Help",
      code: "cw-manage-memory"
    }, {
      title: "会员",
      key: "member",
      route: "/membermanager",
      icon: "User",
      code: "cw-manage-member"
    }, {
      title: "积分商城",
      key: "integral",
      route: "/pointsmanager",
      icon: "Coin",
      code: "cw-manage-finance-integral-core"
    }, {
      title: "财务",
      key: "finance",
      route: "/transactiondetail",
      icon: "Wallet",
      code: "cw-manage-finance"
    }, {
      title: "审批",
      key: "examine",
      route: "/goodsexamine",
      icon: "DocumentChecked",
      code: "cw-manage-approval"
    }, {
      title: "设置",
      key: "setting",
      route: "/companyinformation",
      icon: "Setting",
      code: "cw-manage-install"
    }];
    const getMenuList = ref([]); // const getMenuList = computed(() => {
    //   let list = [];
    //   if (!$.isEmpty(userInfo.value.permissionList)) {
    //     list = menuList.filter((e) => {
    //       for (const key of userInfo.value.permissionList) {
    //         if (key.indexOf(e.code) != -1) {
    //           return true
    //         }
    //       }
    //       return false
    //     });
    //   } else {
    //     list = menuList;
    //   }
    //   return list;
    // });

    const goodsSecondMenu = [{
      title: "商品管理",
      code: "cw-manage-goods-manage",
      itemList: [{
        title: "商品录入",
        route: "/goodsinput",
        code: "cw-manage-goods-manage-add"
      }, {
        title: "商品管理",
        route: "/goodsmanager",
        code: "cw-manage-goods-manage-list"
      }, {
        title: "库存管理",
        route: "/stockmanager",
        code: "cw-manage-goods-manage-stocklist"
      }, {
        title: "库存变更记录",
        route: "/stockrecode",
        code: "cw-manage-goods-manage-stockchangelist"
      }]
    }, {
      title: "商品配置",
      code: "cw-manage-goods-config",
      itemList: [{
        title: "规格管理",
        route: "/specsmanager",
        code: "cw-manage-goods-config-specs"
      }, {
        title: "商品标签管理",
        route: "/goodslabelmanager",
        code: "cw-manage-goods-config-label"
      }, {
        title: "邮费模板管理",
        route: "/expressmanager",
        code: "cw-manage-goods-config-postagetemplate"
      }, {
        title: "自提点管理",
        route: "/takegoodsmanager",
        code: "cw-manage-goods-config-sep"
      }]
    }];
    const travelSecondMenu = [{
      title: "旅行管理",
      code: "cw-manage-travel-manage",
      itemList: [{
        title: "产品录入",
        route: "/travelinput",
        code: "cw-manage-travel-manage-add"
      }, {
        title: "产品管理",
        route: "/travelmanager",
        code: "cw-manage-travel-manage-list"
      }, {
        title: "团期余位管理",
        route: "/groupremainmanager",
        code: "cw-manage-travel-manage-group-remainSeat"
      }]
    }, {
      title: "旅行配置",
      code: "cw-manage-travel-config",
      itemList: [{
        title: "产品属性管理",
        route: "/travellabelmanager",
        code: "cw-manage-travel-config-productlabel"
      }, {
        title: "产品内容管理",
        route: "/groupmanager",
        code: "cw-manage-travel-config-joinnature"
      }, {
        title: '附加费用管理',
        route: '/additionalfeesmanager',
        code: "cw-manage-travel-config-additional-fees"
      }, {
        title: '产品分类管理',
        route: '/travelclassifymanager',
        code: "cw-manage-travel-config-classify"
      }, {
        title: '产品区域管理',
        route: '/TravelAreaManager',
        code: "cw-manage-travel-config-area"
      }]
    }];
    const hotelSecondMenu = [{
      title: "酒店管理",
      code: "cw-manage-hotel-manage",
      itemList: [{
        title: "酒店录入",
        route: "/hotelinput",
        code: "cw-manage-hotel-manage-add"
      }, {
        title: "酒店管理",
        route: "/hotelmanager",
        code: "cw-manage-hotel-manage-list"
      }, {
        title: "库存管理",
        route: "/hotelstockmanager",
        code: "cw-manage-hotel-stock-control"
      }]
    }, {
      title: "酒店配置",
      code: "cw-manage-hotel-config",
      itemList: [{
        title: "酒店设施管理",
        route: "/hotelfacilitiemanager",
        code: "cw-manage-hotel-config-plan"
      }, {
        title: "房间设施管理",
        route: "/roomfacilitiemanager",
        code: "cw-manage-hotel-config-rooms"
      }, {
        title: "餐饮服务管理",
        route: "/servicemanager",
        code: "cw-manage-hotel-config-cateringservice"
      }, {
        title: "酒店标签管理",
        route: "/hotellabelmanager",
        code: "cw-manage-hotel-config-label"
      }]
    }];
    const orderSecondMenu = [{
      title: "订单管理",
      code: "cw-manage-order",
      itemList: [{
        title: "商品订单",
        route: "/goodsorder",
        code: "cw-manage-order-product"
      }, {
        title: "旅行订单",
        route: "/travelorder",
        code: "cw-manage-order-travel-member"
      }, {
        title: "酒店订单",
        route: "/hotelorder",
        code: "cw-manage-order-travel-hotel"
      }, {
        title: "售后订单",
        route: "/aftersaleorder",
        code: "cw-manage-order-after-sale"
      }, {
        title: "团建订单",
        route: "/lineorder",
        code: "cw-manage-order-travel-line"
      }, {
        title: "会员订单",
        route: "/plusorder",
        code: "cw-manage-order-plus"
      }]
    }];
    const marketingSecondMenu = [{
      title: "优惠活动",
      code: "cw-manage-market-activity",
      itemList: [{
        title: "优惠活动管理",
        route: "/promotionsmanager",
        code: "cw-manage-market-activity-list"
      }, {
        title: "综合活动",
        route: "/giftmanager",
        code: "cw-manage-market-activity-giftbag"
      }, {
        title: "旅商活动录入",
        route: "/travelinput2",
        code: "cw-manage-market-manage-add2"
      }, {
        title: "旅商活动管理",
        route: "/travelmanager2",
        code: "cw-manage-market-manage-list2"
      }]
    }, {
      title: "优惠券",
      code: "cw-manage-market-coupon",
      itemList: [{
        title: "优惠券管理",
        route: "/couponmanager",
        code: "cw-manage-market-coupon-list"
      }, {
        title: "定时发放管理",
        route: "/couponTimingManager",
        code: "cw-manage-market-time-send"
      }]
    }, {
      title: "推荐管理",
      code: "cw-manage-market-recommend",
      itemList: [{
        title: "首页Banner图",
        route: "/bannerconfigure",
        code: "cw-manage-market-recommend-homebanner"
      }, {
        title: "首页热门推荐",
        route: "/recommendconfigure",
        code: "cw-manage-market-recommend-hot"
      }, {
        title: "首页活动安排",
        route: "/categoryManager",
        code: "cw-manage-market-classify-list"
      }]
    }, {
      title: "短信营销",
      code: "cw-manage-market-message",
      itemList: [{
        title: "短信营销管理",
        route: "/messagemanage",
        code: "cw-manage-market-message-list"
      }]
    }];
    const financeSecondMenu = [{
      title: "财务管理",
      code: "cw-manage-finance",
      itemList: [{
        title: "结算中心",
        route: "/transactiondetail",
        code: "cw-manage-finance-transactiondetails"
      }, {
        title: "储值管理",
        route: "/depositmanager",
        code: "cw-manage-finance-stored-value"
      }, {
        title: "库存管理",
        route: "/financestockmanager",
        code: "cw-manage-finance-transactiondetails"
      }, {
        title: "出纳管理",
        route: "/cashiermanager",
        code: "cw-manage-finance-transactiondetails"
      }, // {
      //   title: "发票管理",
      //   route: "/invoicemanager",
      //   code: "cw-manage-finance-transactiondetails",
      // },
      // {
      //   title: "合同管理",
      //   route: "/contractmanager",
      //   code: "cw-manage-finance-transactiondetails",
      // },
      {
        title: "基地管理",
        route: "/basemanager2",
        code: "cw-manage-finance-transactiondetails"
      }]
    }, {
      title: "合同管理",
      code: "cw-manage-finance-cashier-contract-manage",
      itemList: [{
        title: "合同管理",
        route: "/contractmanager",
        code: "cw-manage-finance-cashier-contract"
      }, {
        title: "合同类型管理",
        route: "/contractlabelmanager",
        code: "cw-manage-finance-cashier-contract-type"
      }]
    }, {
      title: "积分中心",
      code: "cw-manage-finance-integral-manage",
      itemList: [{
        title: "积分管理",
        route: "/pointsmanager",
        code: "cw-manage-finance-integral"
      }]
    }];
    const examineSecondMenu = [{
      title: "审批中心",
      code: "cw-manage-approval",
      itemList: [{
        title: "商品审批",
        route: "/goodsexamine",
        code: "cw-manage-approval-product"
      }, {
        title: "旅行审批",
        route: "/travelexamine",
        code: "cw-manage-approval-travel"
      }, {
        title: "酒店审批",
        route: "/hotelexamine",
        code: "cw-manage-approval-hotel"
      }, {
        title: "储值审批",
        route: "/depositexamine",
        code: "cw-manage-approval-deposit"
      }, {
        title: "积分审批",
        route: "/pointsexamine",
        code: "cw-manage-approval-rewardpoints"
      }, {
        title: "线路审批",
        route: "/lineexamine",
        code: "cw-manage-approval-line"
      }]
    }];
    const memberSecondMenu = [{
      title: "会员管理",
      code: "cw-manage-member",
      itemList: [{
        title: "会员管理",
        route: "/membermanager",
        code: "cw-manage-member-list"
      }, {
        title: "分销员管理",
        route: "/distributormanager",
        code: "cw-manage-member-distributorshiplist"
      }, {
        title: "权益管理",
        route: "/memberGradePowerManager",
        code: "cw-manage-member-grade-power"
      }, {
        title: "会员分类",
        route: "/memberGradeManager",
        code: "cw-manage-member-grade"
      }, {
        title: "年卡会员管理",
        route: "/memberGradePlusManager",
        code: "cw-manage-member-grade-plus"
      }]
    }];
    const settingSecondMenu = [{
      title: "系统设置",
      code: "cw-manage-install",
      itemList: [{
        title: "公司信息",
        route: "/companyinformation",
        code: "cw-manage-install-company"
      }, {
        title: "基地管理",
        route: "/basemanager",
        code: "cw-manage-install-shop"
      }, {
        title: "用户管理",
        route: "/usermanager",
        code: "cw-manage-install-account"
      }, {
        title: "角色管理",
        route: "/rolemanager",
        code: "cw-manage-install-role"
      }, {
        title: "日志管理",
        route: "/logmanager",
        code: "cw-manage-install-log"
      }]
    }];
    const teamBuildingSecondMenu = [{
      title: "团建管理",
      code: "cw-manage-teamBuilding",
      itemList: [{
        title: "团建管理",
        route: "/lineManager",
        code: "cw-manage-teamBuilding-line"
      }, {
        title: "团建介绍",
        route: "/introduceInfo",
        code: "cw-manage-teamBuilding-introduce"
      }, {
        title: "线路分享",
        route: "/lineSharing",
        code: "cw-manage-teamBuilding-lineSharing"
      }, {
        title: "展示管理",
        route: "/partnershipInfo",
        code: "cw-manage-teamBuilding-partnership"
      }]
    }, {
      title: "线路配置",
      code: "cw-manage-teamBuilding-config",
      itemList: [{
        title: "区域设置",
        route: "/lineAreaConfig",
        code: "cw-manage-teamBuilding-config-area"
      }, {
        title: "类型设置",
        route: "/lineTypeConfig",
        code: "cw-manage-teamBuilding-config-type"
      }]
    } // "cw-manage-teamBuilding-config-type",
    // "cw-manage-teamBuilding-config-area"
    ];
    const memorySecondMenu = [{
      title: "相册管理",
      code: "cw-manage-memory-albumManage",
      itemList: [{
        title: "相册管理",
        route: "/albumManager",
        code: "cw-manage-memory-albumManage"
      }]
    }];
    const integralSecondMenu = [{
      title: "积分商城",
      code: "cw-manage-finance-integral-core",
      itemList: [{
        title: "产品管理-商品",
        route: "/integralProduct",
        code: "cw-manage-finance-integral-product"
      }, {
        title: "产品管理-酒店",
        route: "/integralHotel",
        code: "cw-manage-finance-integral-hotel"
      }, {
        title: "产品管理-旅游",
        route: "/integralTravel",
        code: "cw-manage-finance-integral-travel"
      }]
    }];
    const curSecondMenu = ref("");
    const secondMenu = ref([]);

    function setSecondMenu(value) {
      let list = [];

      switch (value) {
        case "overview":
          list = [];
          break;

        case "goods":
          list = goodsSecondMenu;
          break;

        case "travel":
          list = travelSecondMenu;
          break;

        case "hotel":
          list = hotelSecondMenu;
          break;

        case "order":
          list = orderSecondMenu;
          break;

        case "marketing":
          list = marketingSecondMenu;
          break;

        case "finance":
          list = financeSecondMenu;
          break;

        case "examine":
          list = examineSecondMenu;
          break;

        case "member":
          list = memberSecondMenu;
          break;

        case "setting":
          list = settingSecondMenu;
          break;

        case "teamBuilding":
          list = teamBuildingSecondMenu;
          break;

        case "memory":
          list = memorySecondMenu;
          break;

        case "integral":
          list = integralSecondMenu;
          break;

        default:
          list = [];
      }

      if (!$.isEmpty(userInfo.value.permissionList)) {
        for (let i = list.length - 1; i >= 0; i--) {
          const parent = list[i];
          var parentExist = false;

          for (const permission of userInfo.value.permissionList) {
            if (permission.indexOf(parent.code) != -1) {
              parentExist = true;
              break;
            }
          }

          if (!parentExist) {
            list.splice(i, 1);
          } else {
            parent.itemList = parent.itemList.filter(val => {
              return userInfo.value.permissionList.indexOf(val.code) != -1;
            });
          }
        }
      }

      if (list.length > 0) {
        route.push(list[0].itemList[0].route);
      }

      secondMenu.value = list;
    }

    function navRoute(item) {
      if (item.key === "overview") {
        route.push(menuList[0].route);
      } else {
        setSecondMenu(item.key);
      }
    }

    const route = useRoute();
    route.watchRouter(null, route => {
      let name = route.meta.activeMainMenu;
      console.log('route', name);

      if (name != null && name !== curSecondMenu.value) {
        curSecondMenu.value = name;
      }
    });
    const dialogVisible = ref(false);
    const passwordFormRef = ref("");
    const passwordForm = reactive({
      old: "",
      new: "",
      repetition: ""
    });

    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入重复新密码"));
      } else if (value !== passwordForm.new) {
        callback(new Error("两次输入不匹配!"));
      } else {
        callback();
      }
    };

    const passwordRules = {
      old: [{
        required: true,
        message: "请输入旧密码",
        trigger: "blur"
      }],
      new: [{
        required: true,
        message: "请输入新密码",
        trigger: "blur"
      }],
      repetition: [{
        required: true,
        validator: validatePass2,
        trigger: "blur"
      }]
    };

    function openPassword() {
      dialogVisible.value = true;
    }

    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          changePassword();
        } else {
          console.log("error submit!", fields);
        }
      });
    };

    function changePassword() {
      api.changePassword({
        oldPassword: passwordForm.old,
        newPassword: passwordForm.new
      }, val => {
        logOut();
      });
    }

    function logOut() {
      api.logout(val => {
        getMenuList.value = [];
        permissionsStore.clearPermissions();
        auth.removeToken();
        location.reload();
      });
    }

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_menu_item = _resolveComponent("el-menu-item");

      const _component_el_menu = _resolveComponent("el-menu");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_el_header = _resolveComponent("el-header");

      const _component_el_aside = _resolveComponent("el-aside");

      const _component_router_view = _resolveComponent("router-view");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_container = _resolveComponent("el-container");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_config_provider = _resolveComponent("el-config-provider");

      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [!isLogin.value ? (_openBlock(), _createBlock(LoginViewVue, {
          key: 0
        })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_menu, {
              "default-active": curSecondMenu.value,
              mode: "horizontal"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMenuList.value, item => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  key: item.code,
                  index: item.key
                }, {
                  default: _withCtx(() => [_createElementVNode("div", {
                    class: "menu",
                    onClick: $event => navRoute(item)
                  }, [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
                    _: 2
                  }, 1024), _createTextVNode(" " + _toDisplayString(item.title), 1)], 8, _hoisted_4)]),
                  _: 2
                }, 1032, ["index"]);
              }), 128))]),
              _: 1
            }, 8, ["default-active"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString(userInfo.value.name), 1), _createElementVNode("div", null, _toDisplayString(userInfo.value.roleName), 1), _createElementVNode("div", null, _toDisplayString(userInfo.value.shopName), 1)]), _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  onClick: openPassword
                }, {
                  default: _withCtx(() => [_createTextVNode("修改密码")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  onClick: logOut
                }, {
                  default: _withCtx(() => [_createTextVNode("退出")]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_image, {
                src: userInfo.value.avatar,
                fit: "fill"
              }, {
                error: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, {
                  size: 20
                }, {
                  default: _withCtx(() => [_createVNode(_unref(User))]),
                  _: 1
                })])]),
                _: 1
              }, 8, ["src"]), _createVNode(_component_el_icon, {
                size: 20
              }, {
                default: _withCtx(() => [_createVNode(_unref(CaretBottom))]),
                _: 1
              })])]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_container, null, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_aside, {
              width: "170px"
            }, {
              default: _withCtx(() => [_createVNode(NavMenu, {
                data: secondMenu.value
              }, null, 8, ["data"])]),
              _: 1
            }, 512), [[_vShow, curSecondMenu.value !== 'overview']]), _createVNode(_component_el_main, null, {
              default: _withCtx(() => [_createVNode(_component_router_view)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialogVisible.value = $event),
          title: "修改密码",
          width: "35%",
          top: "30vh",
          class: "base_dialog"
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => submitForm(passwordFormRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = $event => dialogVisible.value = false)
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "passwordFormRef",
            ref: passwordFormRef,
            model: passwordForm,
            rules: passwordRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "旧密码",
              prop: "old"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: passwordForm.old,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => passwordForm.old = $event),
                type: "password",
                "show-password": "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "新密码",
              prop: "new"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: passwordForm.new,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => passwordForm.new = $event),
                type: "password",
                "show-password": "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "重复新密码",
              prop: "repetition"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: passwordForm.repetition,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => passwordForm.repetition = $event),
                type: "password",
                "show-password": "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["locale"]);
    };
  }

};